import { css } from '@emotion/core';

export const appStyle = css`
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
